<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
					<div class="progress-bar-bg">
						<div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
					</div>
				</div>

				<div class="step-nav-buttons mt-4 text-center">
					<button
						type="button"
						class="btn previous-step"
						@click="prevStep"
						v-if="currentStep != 1"
					>
						Back
					</button>
				</div>

				<div class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">


						<div v-if="currentStep === 1">
							<InputElement
								
								fieldText="Property purchase price:"
							>
								<InputTypeNumber currencyPlaceholder v-model="purchasePrice"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 2">
							<BooleanChoiceButtons
								@click="resetCalculation"
								fieldText="Is everyone involved in the purchase considered to be first time buyers?"
								buttonTextLeft="Yes"
								buttonTextRight="No"								
							>
								<template v-slot:left>
									<input @click="resetCalculation" type="radio" v-model="firsttimeBuyers" value="Yes">									
								</template>
								<template v-slot:right>
									<input @click="resetCalculation" type="radio" v-model="firsttimeBuyers" value="No">											
								</template>																
							</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 3">
							<BooleanChoiceButtons
								@click="resetCalculation"
								fieldText="Will the property be your main residence?"
								buttonTextLeft="Yes"
								buttonTextRight="No"								
							>
								<template v-slot:left>
									<input @click="resetCalculation" type="radio" v-model="mainResidence" value="Yes">									
								</template>
								<template v-slot:right>
									<input @click="resetCalculation" type="radio" v-model="mainResidence" value="No">									
								</template>																
							</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 4">
							<BooleanChoiceButtons
								fieldText="Is this property purchase a second home, additional property, or a buy to let property?"
								buttonTextLeft="Yes"
								buttonTextRight="No"								
							>
								<template v-slot:left>
									<input @click="resetCalculation" type="radio" v-model="secondProperty" value="Yes">									
								</template>
								<template v-slot:right>
									<input @click="resetCalculation" type="radio" v-model="secondProperty" value="No">									
								</template>																
							</BooleanChoiceButtons>
						</div>

						<div class="row mb-5" v-if="currentStep === 5">
							<div class="col-12 booleanLabel">Why are you using the calculator today?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="I’m ready to get a mortgage"
								>
								<input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I’m curious to know what I can borrow"
								>
								<input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I want to understand what I can afford before I search for a home"
								>
								<input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div class="step-nav-buttons mt-4 text-center">
							<button
								type="button"
								class="btn next-step"
								@click="nextStep"
								v-if="currentStep != totalSteps - 1 && currentStep != 6"
								:disabled="!isStepValid"
							>
								Continue
							</button>

							<button
								type="button"
								class="btn calculate"
								v-if="currentStep === totalSteps - 1"
								@click="calculate"
								:disabled="!isStepValid"
							>
								Calculate
							</button>
						</div>
						
					</div>

					<div v-if="currentStep === 6" ref="resultsContainer">

						<ResultsContainer class="mt-5 mb-5 calc-results-box">
							<div class="mb-3 results-title" v-if="!isFieldInvalid">Based on a purchase price of:</div>
							<span class="fcs-price" v-if="!isFieldInvalid">£{{formatNumberOutput(purchasePrice)}}</span>
							<div class="mt-3 results-title" v-if="!isFieldInvalid">Your total stamp duty liability would be:</div>
							<span class="fcs-price" v-if="!isFieldInvalid">£{{stampDutyCalculationApril}}</span>
							<div class="mb-3 results-title" v-if="isFieldInvalid">Please select when you will be ready to move forward</div>
						</ResultsContainer>

						<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

					</div>

				</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
		InputElement,
		InputTypeNumber,
		MultiplyChoiceButton,
		ResultsContainer,
		SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
			totalSteps: 6,
      calculatorName: 'stamp-duty-calculator',

      purchasePrice: 0,
      firsttimeBuyers: null,
      mainResidence: null,
      secondProperty: null,
      stampDutyValue: null,
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      isFieldInvalid: false, // Validation state
      listName: "",
      emailAddress: "",
      consent: "",
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    validateField() {
      this.isFieldInvalid = false;
    },
    calculate() {
      if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
      this.validateField(); // Ensure the field is validated before proceeding
			this.stampDutyValue = this.stampDutyCalculationApril;
			this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
          const resultsContainer = this.$refs.resultsContainer;

          if (resultsContainer) {
              // Get the bounding rectangle of the element
              const rect = resultsContainer.getBoundingClientRect();

              // Calculate the target scroll position
              const targetScrollPosition = window.scrollY + rect.top - 200;

              // Scroll to the target position
              window.scrollTo({
                  top: targetScrollPosition,
                  behavior: 'smooth'
              });
          } else {
              console.error('resultsContainer is undefined');
          }
      });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    standardStampDutyApril (propertyPrice, stampDuty) {
			if ( this.secondProperty == null || this.secondProperty === 'No') {
				switch (true) {
					case (propertyPrice < 125000):
						stampDuty = 0;
						break;
					case (propertyPrice >= 125000 && propertyPrice < 250000):
						stampDuty = ( propertyPrice - 125000 ) * 0.02;
						break; //2% on value over £250000
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.05 + 2500;
						break; //5% on value over £925000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.1 + 36250;
						break; //5% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.12 + 93750;
					break; //12% on value over £925000							
				}
				return stampDuty;
			} else {
				switch (true) {
					case (propertyPrice < 125000):
						stampDuty = propertyPrice * 0.05;
						break; //5% on value under £250000
					case (propertyPrice >= 125000 && propertyPrice < 250000):
						stampDuty = ( propertyPrice - 125000 ) * 0.07 + 6250;
						break; //7% on value over £250000
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.1 + 15000;
						break; //5% on value over £925000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.15 + 88750;
						break; //5% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.17 + 196250;
					break; //12% on value over £925000							
				}
				return stampDuty;
			}
		},
    resetCalculation() {
      this.calcCompleted = false;
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
			if (this.currentStep === 3 && this.firsttimeBuyers === 'Yes') {
				this.currentStep = 5;
			} else if (this.currentStep === 2 && this.firsttimeBuyers === 'No') {
				this.currentStep = 4;
			} else if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
		},
		prevStep() {
			if (this.currentStep === 5 && this.firsttimeBuyers === 'Yes') {
				this.currentStep = 3;
			} else if (this.currentStep === 4 && this.firsttimeBuyers === 'No') {
				this.currentStep = 2;
			} else if (this.currentStep === 6) {
				this.currentStep = 5;
			} else if (this.currentStep < this.totalSteps) {
				this.currentStep--;
			}
		},
  },
  computed: {
    isStepValid() {
			if (this.currentStep === 1) {
				return this.purchasePrice != null;
			}
			if (this.currentStep === 2) {
				return this.firsttimeBuyers === 'Yes' || this.firsttimeBuyers === 'No';
			}
			if (this.currentStep === 3) {
				return this.mainResidence === 'Yes' || this.mainResidence === 'No';
			}
			if (this.currentStep === 4) {
				return this.secondProperty === 'Yes' || this.secondProperty === 'No';
			}
			if (this.currentStep === 5) {
				return this.calcReason1 != null;
			}
			return true;
		},
    stampDutyCalculationApril() {
			let stampDuty = 0
			const propertyPrice = Number(this.purchasePrice)

			if ( this.firsttimeBuyers === 'Yes' ) {
				if ( this.mainResidence === 'Yes' ) {
					switch (true) {
						case (propertyPrice < 300000):
							stampDuty = 0;
							break;
						case (propertyPrice >= 300000 && propertyPrice <= 500000):
							stampDuty = ( propertyPrice - 300000 ) * 0.05;
							break; //5% on value over £300000
						case (propertyPrice > 500000):
							stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
					}
				} else {
					stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
				}
			} else {
				stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
			}
			stampDuty = this.formatNumberOutput(stampDuty);
			return stampDuty;
		},
    collateMessageBody() {
      const calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
				Property purchase price: £${parseInt(this.purchasePrice)}
				Is everyone involved in the purchase considered to be first time buyers? ${this.firsttimeBuyers}
				Will the property be your main residence? ${this.formatEmptyMessageFields(this.mainResidence)}
				Is this property purchase a second home, additional property, or a buy-to-let property? ${this.formatEmptyMessageFields(this.secondProperty)}
				Stamp Duty value: ${this.stampDutyValue}
        Why are you using the calculator today: ${this.calcReason1}
        `
      }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>